import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { UrlTrackerService } from 'src/services/url-tracker.service';

@Component({
  selector: 'app-sidebar-menu',
  templateUrl: './sidebar-menu.component.html',
  styleUrls: ['./sidebar-menu.component.scss']
})
export class SidebarMenuComponent implements OnInit {
  currentPath: string | undefined;
  @Input() isExpanded: boolean = false;
  @Output() toggleSidebar: EventEmitter<boolean> = new EventEmitter<boolean>();

  handleSidebarToggle = () => this.toggleSidebar.emit(!this.isExpanded);
  listMenu: any = [
    {
      title: '',
      children: [
        {
          title: 'รายละเอียด PC',
          iconDefault: './assets/images/icon-user-black.png',
          iconActive: './assets/images/icon-user-white.png',
          route: '/',
          noti: null,
          children: []
        },
        {
          title: 'Scan QR code',
          iconDefault: './assets/images/icon-scan-black.png',
          iconActive: './assets/images/icon-scan-white.png',
          route: '/scan',
          noti: null,
          children: []
        },
      ]
    },
  ];
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private urlTrackerService: UrlTrackerService
  ) { }

  currentRoutePath: string = '';
  ngOnInit(): void {
    this.urlTrackerService.currentUrl$.subscribe(url => {
      this.currentRoutePath = url ?? '';
      // console.log('Current URL:', url);
    });
  }

  openMenus: { [key: string]: boolean } = {};

  toggleMenu(menu: string): void {
    this.openMenus[menu] = !this.openMenus[menu];
  }

  setHovered(menu: string, value: boolean): void {
    if (value) {
      this.openMenus[menu] = true;
    } else {
      this.openMenus[menu] = false;
    }
    if (menu == this.currentRoutePath) {
      this.openMenus[menu] = true;
    }
  }

  isMenuOpen(menu: string): boolean {
    return this.openMenus[menu];
  }

  eMainMenu(param: any) {
    if (param.children.length > 0) {
      this.toggleMenu(param.route);
    } else {
      this.router.navigate([param.route]);
    }
  }


  activeTab(param: string) {
    this.router.navigate([param]);
  }

  checkActiveTab(type: string, param: any): boolean {
    var status = this.currentRoutePath === param.route;
    if(status) {
      this.openMenus[param?.route] = true;
    }
    return status;
  }
}

